import { useState, useEffect, useCallback } from 'react';
import { BarcodeType1LookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.tsx';

interface UseBarcodeType1LookupResult {
  barcodeType1s: BarcodeType1LookupItem[];
  loading: boolean;
  error: string | null;
  fetchBarcodeType1s: () => Promise<void>;
}

export const useBarcodeType1Lookup = (): UseBarcodeType1LookupResult => {
  const [barcodeType1s, setBarcodeType1s] = useState<BarcodeType1LookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBarcodeType1s = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: BarcodeType1LookupItem[] }>('/barcode_1', { allPages: true });
      setBarcodeType1s(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch Barcode Type 1s: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching Barcode Type 1s.');
      }
      setBarcodeType1s([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBarcodeType1s();
  }, [fetchBarcodeType1s]);

  return {
    barcodeType1s,
    loading,
    error,
    fetchBarcodeType1s,
  };
};